import { useRef } from 'react';
import { m, yazi } from './markaYollari';
import { useGorunceOyna } from './useMarkaAnimasyonu';

// M monograminin alt yollari ayri ayri cizilsin (tek yolda pathLength hepsine bolunur).
const mParcalari = m.yollar.join('').split(/(?=M)/);

/**
 * Marka jenerigi (uygulama acilisi ve tanitim filmi finaliyle ayni sira):
 * karo yayla belirir -> M kendini cizer ve dolar -> halka yayilir -> "Mahallebi" soldan acilir.
 * Turuncu zemin uzerinde: beyaz karo, turuncu M, beyaz yazi.
 */
export default function MarkaJenerik({ className = '' }: { className?: string }) {
  const ref = useRef<HTMLDivElement>(null);
  const durum = useGorunceOyna(ref, 0.6);

  return (
    <div ref={ref} className={`marka-jenerik ${durum} ${className}`} role="img" aria-label="Mahallebi">
      <span className="mj-kare">
        <span className="mj-halka" />
        <svg viewBox={m.vb} className="mj-m" aria-hidden="true" focusable="false">
          <path className="mj-dolgu" d={m.yollar.join('')} fillRule="evenodd" />
          {mParcalari.map((d, i) => (
            <path key={i} className="mj-hat" d={d} pathLength={1} strokeWidth={22} strokeLinejoin="round" />
          ))}
        </svg>
      </span>
      <svg viewBox={yazi.vb} className="mj-yazi" aria-hidden="true" focusable="false">
        <path d={yazi.yollar.join('')} fillRule="evenodd" />
      </svg>
    </div>
  );
}
